/* Las imagenes deberian ser de 370x180 */ 

export const cardInfo = [
  {
    src: "https://i.ibb.co/xDf54dv/YelpCamp.png",
    alt: "YelpCamp",
    title: "Clon de Yelp especializado en campings",
    description: "Aplicacion CRUD realizada desde el back hasta el front. Conectada a una DB de Mongo. Tiene un login y validaciones client-side. Tambien posee una libreria para manejar geolocalizacion.",
    href: "https://intense-lake-71907.herokuapp.com/",
    repo: "https://github.com/EmilianoTosar/YelpCamp",
  },
  {
    src: "https://i.ibb.co/fdY42zY/React-App.png",
    alt: "Youtube Search App",
    title: "App de busqueda en Youtube",
    description: "App realizada con React en la cual, a traves de la api de YouTube generamos un pequeño clon con su motor de busqueda. Custom hooks, manejo de apis.",
    href: "https://brave-feynman-3b7f00.netlify.app/",
    repo: "https://github.com/EmilianoTosar/yt-app",
  },
  {
    src: "https://i.ibb.co/x8WCnt4/Color-Game.png",
    alt: "Color Guessing Game",
    title: "Juego de adivinanza de colores rgb",
    description: "Juego realizado como un ejercicio de manejo de DOM, enteramente desarrollado con vanilla js",
    href: "https://determined-cori-70d5dc.netlify.app/",
    repo: "https://github.com/EmilianoTosar/rgbGuessingGame",
  },
  {
    src: "https://i.ibb.co/3SnQw8s/porotitos.png",
    alt: "Patatap Clone",
    title: "Clon de Patatap",
    description: "Clon de la app Patatap, la cual genera sonidos y animaciones al presionar las distintas teclas del teclado. Manejo de DOM y utilización de librerías",
    href: "https://flamboyant-yonath-26da56.netlify.app/",
    repo: "https://github.com/EmilianoTosar/patatap-clone",
  },
  {
    src: "https://i.ibb.co/z7NFHZD/https-store-um.png",
    alt: "Store",
    title: "Store con whatsapp checkout",
    description: "Store realizada con typescript y nextjs. Usa como DB un google sheets. También tiene algunos tests de integración. Proyecto en desarrollo.",
    href: "https://store-umber.vercel.app/",
    repo: "https://github.com/EmilianoTosar/store",
  }
]

export const frontendExercises = [
  {
    src: "https://i.ibb.co/MnxS8Rp/Sign-Up-Form.png",
    alt: "Signup form component",
    title: "Signup form component",
    description: "Form hecho enteramente en React, con validaciones client-side",
    href: "http://signup-form-hazel.vercel.app/",
    repo: "https://github.com/EmilianoTosar/signup-form",
  },
  {
    src: "https://i.ibb.co/ZJD6kNC/Static-Job-Listi.png",
    alt: "Static job filtering",
    title: "Static job filtering",
    description: "Hecha en React integramente. Posee un filtro de búsqueda y es 100% interactiva",
    href: "http://static-job-filtering.vercel.app/",
    repo: "https://github.com/EmilianoTosar/static-job-filtering",
  },
  {
    src: "https://i.ibb.co/WHmnjqz/React-App-1.png",
    alt: "Static landing page",
    title: "Static landing page",
    description: "Ejercicio básico de UX, una landing estática realizada con React",
    href: "http://static-landing-page-nine.vercel.app/",
    repo: "https://github.com/EmilianoTosar/static-landing-page",
  },
  {
    src: "https://i.ibb.co/Rzt17Xz/Interactive-Pric.png",
    alt: "Interactive pricing component",
    title: "Interactive pricing component",
    description: "Componente interactivo hecho en React",
    href: "http://interactive-pricing-component-beige-ten.vercel.app/",
    repo: "https://github.com/EmilianoTosar/interactive-pricing-component",
  },
  {
    src: "https://i.ibb.co/S7DcXPC/Frontend-Mentor.png",
    alt: "Static preview component",
    title: "Static preview component",
    description: "Página estática realizada en vanilla js",
    href: "http://static-preview-component.vercel.app/",
    repo: "https://github.com/EmilianoTosar/static-preview-component",
  },
  {
    src: "https://i.ibb.co/kBB07pc/Frontend-Mentor-1.png",
    alt: "Dropdown component",
    title: "Dropdown component",
    description: "Dropdown realizado integramente en vanilla js",
    href: "http://dropdown-component.vercel.app/",
    repo: "https://github.com/EmilianoTosar/dropdown-component",
  },
]
//https://www.awesomescreenshot.com/image/11484638?key=da2b35fbf45d669c15520fd369556658